import EntryActionTypes from '../../constants/EntryActionTypes';

export const createSiteInCurrentFactory = (data) => ({
  type: EntryActionTypes.SITE_IN_CURRENT_FACTORY_CREATE,
  payload: {
    data,
  },
});

export const fetchSite = (id) => ({
  type: EntryActionTypes.SITE_FETCH,
  payload: {
    id,
  },
});

export const updateSite = (id, data) => ({
  type: EntryActionTypes.SITE_UPDATE,
  payload: {
    id,
    data,
  },
});

export const moveSite = (id, index) => ({
  type: EntryActionTypes.SITE_MOVE,
  payload: {
    id,
    index,
  },
});

export const deleteSite = (id) => ({
  type: EntryActionTypes.SITE_DELETE,
  payload: {
    id,
  },
});
